<cerrix-label [for]="name()"><ng-content></ng-content></cerrix-label>
<div class="input-container">
    <cerrix-input
        validationErrors
        [appValidationCannotBeBeforeDate]="mustBeAfter()"
        [dateValue]="value()"
        [beforeDateErrorMessage]="afterErrorMessage()"
        type="text"
        [name]="name()"
        [placeholder]="placeholder()"
        [disabled]="disabled()"
        [required]="required()"
        [value]="displayValue()"
        (input)="onInputTyped($event)"
        (blur)="onInputBlur()"
    ></cerrix-input>
    <mat-icon class="input-icon" svgIcon="calendar" (click)="togglePicker()"></mat-icon>
</div>

<div class="datepicker-container" [hidden]="!isOpen()">
    <div class="datepicker-header">
        @if (view() === "day" && canGoPrevious()) {
            <button class="previous-month" (click)="shiftMonth(-1)">
                <mat-icon svgIcon="arrow-left"></mat-icon>
            </button>
        } @else if (view() === "year") {
            <button class="previous-month" (click)="shiftYearPage(-1)">
                <mat-icon svgIcon="arrow-left"></mat-icon>
            </button>
        }
        <div class="month-year-container">
            @if (view() === "day") {
                <button type="button" class="month-label" (click)="openMonthView()">
                    {{ monthLabel() }}
                </button>
                <button type="button" class="year-label" (click)="openYearView()">
                    {{ viewYear() }}
                </button>
            } @else if (view() === "month") {
                <button type="button" class="year-label" (click)="openYearView()">
                    {{ viewYear() }}
                </button>
            } @else {
                <span>{{ yearPageLabel() }}</span>
            }
        </div>
        @if (view() === "day" && canGoNext()) {
            <button class="next-month" (click)="shiftMonth(1)">
                <mat-icon svgIcon="arrow-right"></mat-icon>
            </button>
        } @else if (view() === "year") {
            <button class="next-month" (click)="shiftYearPage(1)">
                <mat-icon svgIcon="arrow-right"></mat-icon>
            </button>
        }
    </div>
    @if (view() === "day") {
        <div class="datepicker-days-header">
            @for (day of shortDays; track $index) {
                <span>{{ day }}</span>
            }
        </div>
        <div class="datepicker-days">
            @for (cell of days(); track cell.key) {
                <button
                    [class.previous-month]="cell.position === 'previous'"
                    [class.current-month]="cell.position === 'current'"
                    [class.next-month]="cell.position === 'next'"
                    [class.today]="cell.key === todayKey()"
                    [class.active]="cell.key === value()"
                    [class.disabled]="cell.isDisabled"
                    (click)="selectDate(cell)"
                >
                    {{ cell.isDisabled ? "" : cell.day }}
                </button>
            }
        </div>
    } @else if (view() === "month") {
        <div class="datepicker-months">
            @for (cell of months(); track cell.key) {
                <button
                    [class.today]="cell.key === currentMonthKey()"
                    [class.active]="cell.key === selectedMonthKey()"
                    [class.disabled]="cell.isDisabled"
                    (click)="selectMonth(cell)"
                >
                    {{ cell.label }}
                </button>
            }
        </div>
    } @else if (view() === "year") {
        <div class="datepicker-years">
            @for (cell of years(); track cell.key) {
                <button [class.disabled]="cell.isDisabled" (click)="selectYear(cell)">
                    {{ cell.year }}
                </button>
            }
        </div>
    }
</div>
